<template>
  <div>
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="我要求购详情"
      fontSize="0.32rem"
    />
    <div class="form_con">
      <div class="contain_">
        <div class="inner_con">
          <div class="row m_flex_box flex_vc">
            <span class="tit">区域</span>
            <div class="row_r flex-1">
              {{item.area | getAreaName}}
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">预算价格</span>
            <div class="row_r flex-1">
              {{item.exceptPriceLow}}-{{item.exceptPriceHigh}}万元
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">层高</span>
            <div v-show="item.exceptLayer==0" class="row_r flex-1">
              低层
            </div>
            <div v-show="item.exceptLayer==1" class="row_r flex-1">
              中层
            </div>
            <div v-show="item.exceptLayer==2" class="row_r flex-1">
              高层
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">面积</span>
            <div class="row_r flex-1">
              {{item.exceptAreaLow}}m²-{{item.exceptAreaHigh}}m²
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">户型</span>
            <div class="row_r flex-1">
              {{item.room}}室{{item.hall}}厅{{item.toilet}}卫
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">装修状况</span>
            <div v-show="item.decoration==0" class="row_r flex-1">
              毛坯
            </div>
            <div v-show="item.decoration==1" class="row_r flex-1">
              简装
            </div>
            <div v-show="item.decoration==2" class="row_r flex-1">
              精装
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">房屋类别</span>
            <div v-show="item.houseType==0" class="row_r flex-1">
              楼房
            </div>
            <div v-show="item.houseType==1" class="row_r flex-1">
              平房
            </div>
            <div v-show="item.houseType==2" class="row_r flex-1">
              商铺
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">暖气</span>
            <div v-show="item.heating==0" class="row_r flex-1">
              无
            </div>
            <div v-show="item.heating==1" class="row_r flex-1">
              有
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">电梯</span>
            <div v-show="item.elevator==0" class="row_r flex-1">
              无
            </div>
            <div v-show="item.elevator==1" class="row_r flex-1">
              有
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">家具</span>
            <div v-show="item.furniture==0" class="row_r flex-1">
              不带家具
            </div>
            <div v-show="item.furniture==1" class="row_r flex-1">
              带家具
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">家电</span>
            <div v-show="item.appliances==0" class="row_r flex-1">
              不带家电
            </div>
            <div v-show="item.appliances==1" class="row_r flex-1">
              带家电
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">租赁情况</span>
            <div v-show="item.lease==0" class="row_r flex-1">
              否
            </div>
            <div v-show="item.lease==1" class="row_r flex-1">
              是
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">联系电话</span>
            <div class="row_r flex-1">
             {{item.phoneNumber}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from "@/components/header";
export default {
  data() {
    return {
      index: this.$route.query.index,
      loading:false,
      finished:false,
      item:'',
    };
  },
  components: {
    topHeader
  },
  filters: {
    getAreaName (value) {
      if (value == '320300') {
        return '主城区'; //主城区
      }else if (value == '320302') {
        return '鼓楼区';
      }else if (value == '320311') {
        return '泉山区';
      }else if (value == '320303') {
        return '云龙区';
      }else if (value == '320398') {
        return '开发区';
      }else if (value == '320312') {
        return '铜山区';
      }else if (value == '320399') {
        return '高新区';
      }else if (value == '320397') {
        return '港务区';
      } else if (value == '320305') {
        return '贾汪区';
      } else if (value == '320321') {
        return '丰县';
      } else if (value == '320381') {
        return '新沂市';
      } else if (value == '320324') {
        return '睢宁县';
      } else if (value == '320322') {
        return '沛县';
      } else if (value == '320382') {
        return '邳州市';
      } else {
        return '主城区';
      }
    },
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          var str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
      }
      return fmt;
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http.post('cms/housePurchaseBasicInformation/reg/searchScreenListedUserCenter.do', qs.stringify({
        pageSize:1,
        currPageNo:this.index,
      })).then(res => {
        if (res.success) {
            this.item = res.obj.rows[0];
            this.loading = false;
            this.finished = true;
        } else {
          this.finished = true;
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
.contain_ {
  padding-bottom: 1px;
  .blue_con{
    background-color: #EFF4FF;
    width: 7.04rem;
    margin: 0 auto 0.4rem;
    padding: 0.16rem 0.4rem;
    box-sizing: border-box;
    color: #2F72F5;
    font-size: 0.26rem;
    line-height: 0.4rem;
  }
  h3 {
    font-size: 0.34rem;
    font-weight: 800;
    padding: 0.4rem 0 0rem;
    width: 7.04rem;
    margin: 0 auto;
  }
}
.info_con {
  margin: 0rem auto 0rem;
  width: 7.04rem;
  .inner {
    padding: 0.3rem 0;
    font-size: 0.26rem;
    border-bottom: 1px solid #f5f5f5;
    p {
      margin-bottom: 0.2rem;
      line-height: 0.42rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .tit {
      box-sizing: border-box;
      color: #909090;
    }
    .text {
      max-width: 70%;
    }
  }
}
.inner_con{
  width: 7.04rem;
  font-size: 14px;
  margin: 0 auto;
  overflow: hidden;
  .tit{
    width: 1.9rem;
    font-weight: 800;
  }
  .row{
    min-height: 44px;
    border-bottom: 1px solid #f5f5f5;
    .van-radio-group{
      padding-left: 16px;
    }
  }
}
.checkbox_con, .textarea_con{
  padding: 0.4rem 0 0.2rem;
  overflow: hidden;
  border-bottom: 1px solid #f5f5f5;
  h5{
    font-weight: 800;
    font-size: 14px;
    margin-bottom: 0.3rem;
  }
  .check_inner{
    margin-right: -0.16rem;
    span{
      line-height: 0.52rem;
      padding: 0 12px;
      background-color: #F2F2F2;
      color: #989898;
      display: inline-block;
      margin-bottom: 0.16rem;
      margin-right: 0.16rem;
      &.active{
        background-color: rgb(0,123,255);
        color: #fff;
      }
    }
  }
}
.textarea_con{
  /deep/
  .van-cell{
    background-color: #F8F8F8;
  }
}
.col_ori{
  color: #FF3C1C;
  font-size: 0.26rem;
  font-weight: 400;
  margin-left: 10px;
}
.pic_con{
  padding-top: 0.3rem;
  padding-bottom: 0.2rem;
  margin-right: -0.2rem;
  .inner{
    height: 2.66rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    position: relative;
    .show_img{
      width: 2.2rem;
      height: 2.2rem;
    }
    .del{
      position: absolute;
      width: 0.4rem;
      top: 0.16rem;
      right: 0.16rem;
    }
    p{
      width: 2.2rem;
      height: 0.46rem;
      color: #606060;
      font-size: 0.22rem;
      box-sizing: border-box;
      border: 1px solid #E0E0E0;
      .van-icon{
        transform: rotate(90deg);
      }
    }
  }
}
/deep/
.van-uploader__upload{
  width: 2.2rem;
  height: 2.2rem;
  margin: 0;
}
.btn_con{
  padding: 0rem 0 0.6rem;
}
.btn{
  border-radius: 0.08rem;
  background-color: #2F72F5;
  line-height: 0.74rem;
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  width: 7.04rem;
  margin: 0 auto;
}
</style>